export const setValue = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getValue = (key) => {
  return JSON.parse(localStorage.getItem(key));
};

export const removeValue = (key) => {
  localStorage.removeItem(key);
};
